import * as HttpService from '../HttpService'

let npmNamespace = 'https://api.npmjs.org/downloads/point/last-year/@deveodk/'
let githubNamespace = 'https://api.github.com/repos/Deveodk/'
let packagistNamespace = 'https://packagist.org/packages/deveodk/'

let getDownloads = (repo, params, cb, errorCb) => {
    HttpService.get(npmNamespace + repo, params, cb, errorCb)
}

let getStars = (repo, params, cb, errorCb) => {
    HttpService.get(githubNamespace + repo, params, cb, errorCb)
}

let getPackagistDownloads = (repo, params, cb, errorCb) => {
    HttpService.get(packagistNamespace + repo + '.json', params, cb, errorCb)
}

export {
    getDownloads,
    getStars,
    getPackagistDownloads
}



// WEBPACK FOOTER //
// ./src/infrastructure/services/packages/packageService.js